import { User } from '@/features/user/types/user';

export default function transformUserResponse(userObj: any): User {
  const user = userObj;

  return {
    id: user.id,
    username: user.username,
    userNumber: user.userNumber,
    __role: user.role || 'ROLE_WEBSHOP_USER',
    published: user.published ?? true,
    about: {
      fullName: user.fullName,
      jobTitle: user.jobTitle,
      company: user.Company,
    },
    contactInfo: {
      email: user.email,
      phoneNumber: user.phoneNumber,
      defaultCommunication: user.defaultCommunication,
      defaultCommunicationLanguage: user.defaultCommunicationLanguage,
    },
    shippingAddress: {
      address: user.address,
      city: user.city,
      state: user.state,
      zipCode: user.zipcode,
      country: user.country,
    },
    credit: {
      currencyType: user.currencyType,
      lineObligo: user.lineObligo ?? 0,
      utilizedObligo: user.utilizedObligo ?? 0,
      unutilizedObligo: user.unutilizedObligo ?? 0,
      deferredChequeTotal: user.deferredChequeTotal ?? 0,
      openOrderValue: user.openOrderValue ?? 0,
      openDebt: user.openDebt ?? 0,
      unbilledDN: user.unbilledDN ?? 0,
      paymentTerms: user.paymentTerms ?? 120,
    },
    targetInfo: {
      targetSales: user.targetSales ?? 0,
      amountOrdered: user.amountOrdered ?? 0,
      percentageAccomplished: user.percentageAccomplished ?? 0,
      fromDate: user.fromDate ?? 0,
      toDate: user.toDate ?? 0,
    },
    trackingConsent: user.trackingConsent,
    lastReservedStockSyncTimestamp: user.lastReservedStockSyncTimestamp ?? null,
  };
}
